/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2021-04-28 15:56:18
 * @FilePath: /yft-b2c-web-h5/src/pages/Shop/Member/Wallet/MyWallet/MyWalletMod.js
 */
import { observable, action, flow } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './BonusWalletServ';

class BonusWalletMod {
  @observable walletBalance = 0; // 钱包余额

  @observable accumulatedSales = 0; // 累计收益

  @observable recommendedAward = 0; // 预计收益

  @observable walletBonus = 0; // 分红积分

  @observable commissionAmount = 0; // 可消费可转账金额

  @observable expectedProfit = 0; // 不可用余额

  @observable hasBonus = false; // 是否有分红积分

  @observable cisternBalance = 0; // 蓄水池余额

  @observable chargeAmountSum = 0; // 钱包累计充值金额

  @observable restBalance = 0; // 预计收益，后管体系配置了销售费到账时限为延时到账

  @observable latestTransaction = null; // 最新一项明细

  @observable totalCoupon = 0; // 优惠券数量

  @observable exchangeCouponCount = 0; // 产品兑换券数量

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取钱包信息
   */
  getWalletInfo = flow(function* (params) {
    try {
      const { data } = yield Serv.getWalletInfo(params);
      if (data && data.length > 0) {
        for (const item of data) {
          const {
            accountType,
            usefulBalance,
            chargeAmountSum,
            commissionAmount,
            expectedProfit,
            restBalance,
            accumulatedSales
          } = item;
          switch (accountType) {
            case 'NOMAL':
              this.walletBalance = usefulBalance || 0;
              this.chargeAmountSum = chargeAmountSum || 0;
              break;
            case 'CISTERN':
              this.cisternBalance = usefulBalance || 0;
              break;
            case 'BONUS':
              this.walletBonus = usefulBalance || 0;
              this.commissionAmount = commissionAmount;
              this.expectedProfit = expectedProfit;
              this.restBalance = restBalance;
              this.hasBonus = true;
              this.accumulatedSales = accumulatedSales;
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {}
  });

  /**
   * 获取最新一项明细
   */
  getLatestTransaction = flow(function* () {
    try {
      const { data } = yield Serv.getLatestTransaction();
      if (data && data.list) {
        this.latestTransaction = data.list[0];
      }
    } catch (error) {}
  });

  // 获取预计收益
  getRecommendedAward = flow(function* (callback) {
    const cardCode = Stores.AppMod.userInfo.cardCode;
    if (!cardCode) return;
    try {
      const { data, resultCode } = yield Serv.getRecommendedAward(cardCode);
      if (resultCode == 0) {
        this.recommendedAward = data.jj || 0;
      }
      callback && callback();
    } catch (error) {}
  });

  @action
  clearData() {
    this.walletBalance = 0;
    this.cisternBalance = 0;
    this.latestTransaction = null;
    this.recommendedAward = 0;
  }

  /**
   * 获取各种优惠券数量
   */
  getCouponCount = flow(function* () {
    const { data } = yield Serv.getCouponCount({
      userId: Stores.AppMod.userInfo.id
    });
    this.totalCoupon = 0;
    data.forEach((item) => {
      this.totalCoupon += item.count;
      if (item.couponType == 5) {
        this.exchangeCouponCount = item.count;
      }
    });
  });
}

const bonusWalletMod = new BonusWalletMod();
export default bonusWalletMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/BonusWallet/BonusWalletMod.js